import React from "react";
import { StaffFrame, AgentView, PageHead } from "./DashboardShared";
import { useShowToast } from "../components/Notify";

export default function AgentPage() {
  const showToast = useShowToast();

  return (
    <StaffFrame>
      <div className="page">
        <PageHead title="Émission de billets" sub="Recherchez un trajet et émettez un billet pour un passager" />
        <AgentView activePage="search" showToast={showToast} />
      </div>
    </StaffFrame>
  );
}
